export default function(e, inputval = null, maxlength = null) {
  if (
    e.key.length === 1 &&
    maxlength &&
    inputval &&
    inputval.length >= maxlength
  ) {
    e.preventDefault()
    e.stopPropagation()
    return
  }
  if (isNaN(e.key) && e.key.length === 1) {
    e.preventDefault()
    e.stopPropagation()
  }
}
